export default __webpack_public_path__ + "static/media/logoVolupia.135ae324.png";